module.exports = __webpack_public_path__ + "src/assets/img/share/tips/nervousness/40b20fecbd2adf8c33308ebe44fdca12.png";